
import axios from 'axios';
import Cookie from 'js-cookie';

export default class ApiClient {
  constructor ({ prefix = 'api/v2/' } = {}) {
    this.prefix = prefix;
  }

  axios () {
    return axios;
  }

  get (url, query = {}, token = null) {
    return this.request({
      method: 'get',
      url,
      query,
      token
    });
  }

  put (url, data = {}, token) {
    return this.request({
      method: 'put',
      url,
      data,
      token
    });
  }

  patch (url, data = {}, token) {
    return this.request({
      method: 'patch',
      url,
      data,
      token
    });
  }

  post (url, data = {}, token) {
    return this.request({
      method: 'post',
      url,
      data,
      token
    });
  }

  delete (url, token) {
    return this.request({
      method: 'delete',
      url,
      token
    });
  }

  getHeaders (token) {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-MLSN-User-Agent': '323:340:2.0.0'
    };

    token = token || Cookie.get('msessionid');
    if (token) {
      headers['Authorization'] = 'Bearer ' + token;
    }

    return headers;
  }

  request ({ url, method, query = {}, data = {}, token }) {
    const headers = this.getHeaders(token);

    const config = {
      baseURL: this.prefix,
      url,
      method,
      headers,
      data,
      params: query,
      withCredentials: true,
      validateStatus: function (status) {
        return status < 500;
      }
    };

    return axios(config)
      .then(res => {
        if (res.status >= 400) {
          const error = new Error('Bad request: code ' + res.status);
          error.responseCode = res.status;

          switch (res.status) {
            case 401:
              error.messages = [{
                field: 'authorization',
                message: 'Необходима авторизация'
              }];
              break;
            default:
              error.messages = res.data;
          }

          throw error;
        }

        return res.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/api/ApiClient.js